<template>
  <div
    v-if="show"
    class="modal fade show"
    style="display: block;"
    tabindex="-1"
    aria-labelledby="agendaConfirmationModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="agendaConfirmationModalLabel">
            <span v-t="'message.Agenda.confirmation_modal_title'"></span>
          </h5>
          <button
            type="button"
            class="btn-close"
            @click="closeModal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="text-center">
            <i class="bi bi-check-circle-fill text-success fs-1 mb-3"></i>
            <p class="mb-3">
              <span v-t="'message.Agenda.confirmation_modal_message'"></span>
            </p>
            <div class="spinner-border text-primary" role="status" v-if="loading">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
        <div class="modal-footer" v-if="!loading">
          <button
            type="button"
            class="btn btn-primary"
            @click="proceedToMainPage"
          >
            <span v-t="'message.Agenda.complete_button'"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script setup>
import { ref } from "vue";
import { useAgendaStore } from "@/stores/parent/agenda";
import { useConferenceStore } from "@/stores/parent/conference";
import { useRouter, useRoute } from "vue-router";

const agendaStore = useAgendaStore();
const conferenceStore = useConferenceStore();
const router = useRouter();
const route = useRoute();

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:show']);

const loading = ref(false);

function closeModal() {
  emit('update:show', false);
  agendaStore.showConfirmationModal = false;
}

async function proceedToMainPage() {
  loading.value = true;
  try {
    await agendaStore.getEmail(conferenceStore.selected?.conference_id);
    router.push("/" + route.params.account);
  } catch (error) {
    console.error('Error getting email:', error);
  } finally {
    loading.value = false;
    closeModal();
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.5;
}

.modal {
  z-index: 1050;
}
</style>
